export const DATE_DETAILS_STEP = 0;

export const ASSIGN_TICKETS_STEP = 1;
